export const budgetBidsStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({

  '& .budget-bid-settings': {

    marginBottom: '123px !important',
    borderBottom: `1px solid ${palette.neutralSecondary}`,

    /** **************budget begin******* */

    '& .control-label:first-child:': {
      marginTop: 26,
    },

    '& .budget-suggestion-container': {
      display: 'inline-block',
      border: '1px solid #0078d7',
      padding: '10px 8px',
      fontSize: '12px',
      height: '38.67px',

      '& .iconba-Lightbulb': {
        marginRight: '8px',
        top: '-1px',
        color: '#0078d4',
        verticalAlign: 'text-bottom',
      },

      '& .budget-suggestion': {
        marginRight: '8px',
        verticalAlign: 'baseline',
      },

      '& .use-suggested-budget': {
        boxSizing: 'border-box',
        background: '#ffffff',
        border: '1px solid #8a8886',
        borderRadius: '2px',
        padding: '4px 16px',
        top: '-4px',
        height: '24.67px',
        lineHeight: 1,
      },
    },

    /** **************Bid strategy begin******* */

    '& .bidding-strategy__container': {
      marginTop: 12,

      '& select': {
        margin: '5px 0',
        width: 460,
      },
      '& div[data-bind="visible: checkCPC"]': {
        paddingTop: 8,
      },
      '& input[type="checkbox"]': {
        float: 'left',
      },
      '& .custom-param__key-field': {
        display: 'inline-block',
        width: 85,
        marginLeft: 5,
        marginRight: 5,
      },
      '& #currencyLabelTargetCpa': {
        display: 'inline-block',
        'vertical-align': 'initial',
        marginTop: 0,
      },
      '& #currencyLabelTargetRoas': {
        display: 'inline-block',
        'vertical-align': 'initial',
        marginTop: 0,
      },
      '& .alert.alert-info': {
        marginTop: 8,
      },
      '& .alert-image': {
        paddingTop: 3,
      },
      '& a.helpbutton': {
        'margin-left': '5px',
      },
    },


    /** **************performance-grid begin******* */

    '& .performance-grid': {
      margin: '7px 0 0 15px',
      width: 983,
      padding: 0,
      paddingBottom: 37,

      '& .bidBoost-percentValue': {
        width: 'auto',
        display: 'inline-block',
      },

      '& .popover': {
        border: 'none',
        boxShadow: 'none',
      },

      '& .popover-content': {
        width: 342,
        height: 159,
        padding: '9px 24px',
        border: '1px solid #edebe9',
        boxShadow: '0px 6.4px 14.4px 0px rgb(0 0 0 / 13%), 0px 1.2px 3.6px 0px rgb(0 0 0 / 11%)',
        borderRadius: '2px',
      },

      '& .table>thead>tr>th': {
        verticalAlign: 'top',
        textAlign: 'left',
        border: `1px solid ${palette.neutralLight}`,
        fontWeight: 'normal',
      },

      '& .table>tbody>tr>td': {
        verticalAlign: 'middle',
        padding: '0 10px',
        height: 42,
        border: `1px solid ${palette.neutralLight}`,
      },

      '& .table>tbody>tr>td:first-child > span': {
        display: 'inline-block',
        overflow: 'hidden',
        maxWidth: '300px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },

      '& .table__row--indent td:first-child': {
        paddingLeft: '32px !important',
      },

      '& .table>thead>tr>th span': {
        display: 'inline-block',
        maxWidth: '80%',
      },

      '& .footer': {
        '& .header-subview-0': {
          border: 0,
        },
      },

      '& .grid-error-list': {
        margin: 0,

        '& .error-message': {
          color: '#A80000',
        },
      },
    },
    '& .low-bid-title': {
      fontWeight: 600,
      fontSize: '20px',
      paddingTop: '8px',
    },
    '& .low-bid-subcontent': {
      fontWeight: 400,
      fontSize: '12px',
      paddingBottom: '21px',
    },

    '& .grid-header-helpId': {
      verticalAlign: 'top',
    },

    '& .grid-header-text': {
      fontWeight: 'normal',
    },

    '& .form-control input-bid': {
      border: `1px solid ${palette.neutralSecondary}`,
      borderRadius: 2,
    },

    '& .status-row .col-sm-9': {
      padding: 0,
    },

    '& .status-row .col-sm-10': {
      padding: 0,
    },

    '& .bid-status-icon, .bid-hint-text': {
      padding: 0,
      marginTop: 6,
      width: 14,
    },

    '& .bid-hint-text': {
      marginLeft: 4,
    },

    '& .status_warning': {
      color: '#d83B01',
      fontFamily: iconFontFamily,
      fontSize: 16,
    },

    '& .status_warning:before': {
      content: '"\\E7BA"',
    },

    '& .bid-status-icon': {
      position: 'relative',
      left: '-4px',
      top: '-1px',
    },

    '& .status_icon': {
      fontFamily: iconFontFamily,
      float: 'right',
      textDecoration: 'none',
      background: 'none',
    },

    '& .status_icon:before, .status_icon_hover:before': {
      content: '"\\E712"',
    },

    '& .form-group > #KoErrors': {
      marginLeft: 15,
      marginRight: 15,
    },

    '& #KoErrors': {
      paddingLeft: 8,
    },

    '& .critical-low-bid': {
      color: '#D83B01',
      fontSize: 14,
      fontFamily: 'Segoe UI',
      fontWeight: 400,
      width: 51,
      top: '-1px',
      borderBottom: '1px dashed #0078D4',
    },

    '& .status-row.row': {
      paddingRight: '12px',
    },

    '& .iconba-Lightbulb': {
      color: '#0078D4',
      fontSize: 16,
    },

    '& .low-bid-footer': {
      fontWeight: 400,
      fontSize: 14,
      paddingTop: '20px',
    },

    '& .apply-link': {
      paddingRight: 10,
      fontSize: 14,
    },

    '& .cancel-link': {
      paddingLeft: 10,
      fontSize: 14,
    },

    '& .estimated-num-val': {
      paddingLeft: 4,
    },

    '& .raise-bid-popup-content.normal-low-bid': {
      width: 342,
      height: 159,
      padding: '9px 24px',
      '& .normal-low-bid-content': {
        marginTop: '9px',

        '& .normal-low-bid-title': {
          paddingTop: '7px',
          fontWeight: 600,
          fontSize: 20,
          lineHeight: '28px',
        },
        '& .normal-low-bid-subcontent': {
          fontSize: 12,
          lineHeight: '16px',
          paddingTop: '4px',
        },
        '& .normal-low-bid-footer': {
          fontWeight: 400,
          fontSize: 14,
          lineHeight: '22px',
          paddingTop: '16px',
        },
      },
    },

    /** **************campaign-targets begin******* */

    '& a[data-target=".campaign-targets"]': {
      fontSize: 18,
      marginLeft: 15,
      marginBottom: 15,
      padding: '8px 0 20px 0',
      borderTop: `1px solid ${palette.neutralSecondary}`,
      width: 'calc(100% - 30px)',
      backgroundClip: 'content-box',

      '& .expanderImage, .expandedImage': {
        fontSize: 18,
        marginRight: 11,
      },
      '&:hover': {
        borderBottom: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        textDecoration: 'none',
        backgroundColor: '#F3F2F1',
      },
      '&:focus': {
        borderBottom: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        textDecoration: 'none',
      },
      '&:focus::after': {
        border: '1px solid',
        borderColor: palette.neutralSecondary,
        textDecoration: 'none',
        content: '""',
        width: '100%',
        display: 'block',
        height: '32px',
        top: '8px',
        position: 'absolute',
      },
    },

    '& .campaign-targets': {
      paddingLeft: 38,
      padding: 0,

      '& .audience-advanced-target-settings': {
        marginTop: '-20px',
        padding: 0,

        '& a.toggle-edit-target-category': {
          padding: '0px 8px 5px 8px',
          position: 'relative',
          left: '-8px',
        },
      },

      '& .audience-target-selector-container': {
        marginBottom: '-30px',
      },
    },
  },

});

